import axios from "axios";

const rawBackend = process.env.REACT_APP_BACKEND_URL || "/api";
export const API = rawBackend.endsWith("/api") ? rawBackend : `${rawBackend}/api`;

const instance = axios.create({ baseURL: API });

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("tf_token") || sessionStorage.getItem("tf_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error("API ERROR: ", error.config.url, error.response.status);
    } else {
      console.error("NETWORK ERROR: ", error.config.url);
    }
    return Promise.reject(error);
  }
);

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail);
};

export default instance;
